/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacilityPayorConfig } from './FacilityPayorConfig';
import {
    FacilityPayorConfigFromJSON,
    FacilityPayorConfigFromJSONTyped,
    FacilityPayorConfigToJSON,
    FacilityPayorConfigToJSONTyped,
} from './FacilityPayorConfig';

/**
 * 
 * @export
 * @interface GetPayorConfigForFacility200Response
 */
export interface GetPayorConfigForFacility200Response {
    /**
     * 
     */
    data?: FacilityPayorConfig;
}

/**
 * Check if a given object implements the GetPayorConfigForFacility200Response interface.
 */
export function instanceOfGetPayorConfigForFacility200Response(value: object): value is GetPayorConfigForFacility200Response {
    return true;
}

export function GetPayorConfigForFacility200ResponseFromJSON(json: any): GetPayorConfigForFacility200Response {
    return GetPayorConfigForFacility200ResponseFromJSONTyped(json, false);
}

export function GetPayorConfigForFacility200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPayorConfigForFacility200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FacilityPayorConfigFromJSON(json['data']),
    };
}

export function GetPayorConfigForFacility200ResponseToJSON(json: any): GetPayorConfigForFacility200Response {
    return GetPayorConfigForFacility200ResponseToJSONTyped(json, false);
}

export function GetPayorConfigForFacility200ResponseToJSONTyped(value?: GetPayorConfigForFacility200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FacilityPayorConfigToJSON(value['data']),
    };
}

